<template>
  <div class="page">
    <van-nav-bar title="AI 公司策略建议" left-arrow @click-left="$router.back()"/>
    <div class="action">
      <van-button block type="primary" :loading="generating" @click="generate">结合情报、绩效与平台表现生成</van-button>
    </div>
    <section v-for="row in rows" :key="field(row,'id')"><h2>{{ parsed(row).title }}</h2>
      <p>{{ parsed(row).summary }}</p>
      <van-cell v-for="(s,i) in parsed(row).suggestions||[]" :key="i" :title="s.direction"
                :label="(s.targetPlatform||'平台待验证')+' · '+(s.contentType||'形式待验证')+' · '+(s.publishWindow||'时段待验证')+'\n'+s.reason"/>
      <div class="buttons">
        <van-button size="small" type="danger" @click="patch(row)">生成 brand.* 修订草稿</van-button>
      </div>
    </section>
    <van-empty v-if="!rows.length" description="暂无公司策略建议"/>
  </div>
</template>
<script>import api from '@/api/brand';

export default {
  data() {
    return {rows: [], generating: false}
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, parsed(r) {
      const v = this.field(r, 'advice_json');
      if (typeof v === 'object') return v;
      try {
        return JSON.parse(v || '{}')
      } catch (e) {
        return {}
      }
    }, async load() {
      try {
        this.rows = await api.advices({scopeType: 'COMPANY'})
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }, async generate() {
      this.generating = true;
      try {
        await api.generateAdvice({scopeType: 'COMPANY'});
        await this.load()
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.generating = false
      }
    }, async patch(row) {
      try {
        const r = await api.createSkillPatch(this.field(row, 'id'));
        this.$dialog.alert({title: '修订草稿已生成', message: '编号 ' + r.suggestionId + '。需到运营端执行 shadow 门禁，通过后才能发布。'})
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
};</script>
<style scoped>.page {
  min-height: 100vh;
  background: #f5f6f8
}

.action {
  padding: .3rem;
  background: #fff
}

section {
  background: #fff;
  margin-top: .2rem;
  padding: .3rem
}

h2 {
  font-size: .32rem;
  margin: 0
}

p {
  font-size: .25rem;
  color: #555
}

.buttons {
  padding-top: .2rem
}</style>



// WEBPACK FOOTER //
// src/views/brand/StrategyAdvice.vue